import { combineReducers } from 'redux';

import AuctionReducer from './auction/AuctionReducer';
import AuthReducer from './auth/AuthReducer';
import CarrierRegistrationReducer from './CarrierRegistration/CarrierRegistrationReducer';
import LossAndDamageClaimsReducer from './Claims/LossAndDamage/LossAndDamageClaimsReducer';
import { OverChargeClaimsReducer } from './Claims/OverCharge/OverChargeReducer';
import CommonReducer from './common/CommonReducer';
import DashboardReducer from './Dashboard/DashboardReducer';
import LookupsReducer from './lookups/LookupsReducer';
import MessageCenterReducer from './MessageCenter/MessageCenterReducer';
import POShipmentDraftSearchReducer from './POShipmentDraftSearch/POShipmentDraftSearchReducer';
import POShipmentPreBookingSearchReducer from './POShipmentPreBookingSearch/POShipmentPreBookingSearchReducer';
import POShipmentSearchReducer from './POShipmentSearch/POShipmentSearchReducer';
import POVReducer from './POV/POVReducer';
import ProcurementProjectReducer from './Procurement/Project/ProcurementProjectReducer';
import ProcurementLaneReducer from './Procurement/RouteConfig/Lane/ProcurementLaneReducer';
import ProcurementLocationReducer from './Procurement/RouteConfig/Location/ProcurementLocationReducer';
import ProcurementZoneReducer from './Procurement/RouteConfig/Zone/ProcurementZoneReducer';
import ProcurementTenderReducer from './Procurement/Tender/ProcurementTenderReducer';
import PurchaseOrderReducer from './purchaseOrder/PurchaseOrderReducer';
import RateShopReducer from './RateShop/RateShopReducer';
import RoutingGuideReducer from './RoutingGuide/RoutingGuideReducer';
import SaversReducer from './Savers/SaversReducer';
import SettingsReducer from './settings/SettingsReducer';
import ShipmentReducer from './shipment/ShipmentReducer';
import VisibilityReducer from './visibility/VisibilityReducer';

export type RootState = ReturnType<typeof rootReducer>;

const appReducer = combineReducers({
  auction: AuctionReducer,
  auth: AuthReducer,
  carrierRegistration: CarrierRegistrationReducer,
  common: CommonReducer,
  dashboard: DashboardReducer,
  lookups: LookupsReducer,
  lossAndDamage: LossAndDamageClaimsReducer,
  messageCenter: MessageCenterReducer,
  overChargeClaims: OverChargeClaimsReducer,
  poShipmentDraftSearch: POShipmentDraftSearchReducer,
  poShipmentPreBookingSearch: POShipmentPreBookingSearchReducer,
  poShipmentSearch: POShipmentSearchReducer,
  poVendor: POVReducer,
  procurementLane: ProcurementLaneReducer,
  procurementLocation: ProcurementLocationReducer,
  procurementProject: ProcurementProjectReducer,
  procurementTender: ProcurementTenderReducer,
  procurementZone: ProcurementZoneReducer,
  purchaseOrder: PurchaseOrderReducer,
  rateShop: RateShopReducer,
  routingGuide: RoutingGuideReducer,
  savers: SaversReducer,
  settings: SettingsReducer,
  shipment: ShipmentReducer,
  visibility: VisibilityReducer,
});

// biome-ignore lint/suspicious/noExplicitAny: fix
export const rootReducer = (state: any, action: any) => {
  return appReducer(state, action);
};
